import React from "react";

import { Field, Label, ErrorMessage } from "../../../common/fieldset";
import { DatePicker } from "antd";

import * as dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function StartAndEndDateField(props) {
  const {
    error,
    setError,
    setDate,
    hideLabel,
    date,
    timezone,
    size = "middle",
    showTime = false,
    allowClear = true,
    format = "YYYY-MM-DD",
    autoEndOfDay = true,
  } = props;

  const [startDate, endDate] = date || ["", ""];

  const isDatesAvailable = Boolean(startDate) && Boolean(endDate);

  function onDateChange(date, dateString) {
    if (error.isError) {
      setError({
        isError: false,
        message: "",
      });
    }

    if (!Boolean(date)) {
      setDate({ startDate: "", endDate: "" });
      return;
    }

    if (timezone) {
      const [startDate, endDate] = dateString;

      const updatedStartDate = dayjs.tz(startDate, timezone);
      const updatedEndDate = dayjs
        .tz(endDate, timezone)
        .set("hour", 23)
        .set("minute", 59);

      setDate({
        startDate: updatedStartDate.utc().format("x"),
        endDate: updatedEndDate.utc().format("x"),
      });

      return;
    }

    const [startDate, endDate] = date;

    const updatedStartDate = dayjs(startDate);
    const updatedEndDate = autoEndOfDay
      ? dayjs(endDate).set("hour", 23).set("minute", 59)
      : dayjs(endDate);

    setDate({
      startDate: updatedStartDate.format("x"),
      endDate: updatedEndDate.format("x"),
    });
  }

  return (
    <div className="w-full">
      <Field>
        {!hideLabel && <Label>Choose Start & End date</Label>}
        <DatePicker.RangePicker
          size={size}
          className="border-slate-200 font-medium text-xl w-full"
          maxDate={dayjs()}
          {...(isDatesAvailable
            ? { value: [dayjs(Number(startDate)), dayjs(Number(endDate))] }
            : {})}
          variant="outlined"
          placeholder={["Start date", "End date"]}
          onChange={onDateChange}
          status={error.isError && "error"}
          format={format}
          showTime={showTime}
          allowClear={allowClear}
        />
        {error.isError && (
          <ErrorMessage className="pt-2">{error.message}</ErrorMessage>
        )}
      </Field>
    </div>
  );
}
